module.exports = __webpack_public_path__ + "img/border_shield.a836920f.svg";